import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Shadows from 'builder/styles/shadows'
import Media from 'builder/styles/media'

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 64px;

  ${Media.Phone`
    gap: 40px;
  `}
`

export const PTContainer = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  background-color: transparent;

  ${Media.Tablet` flex-direction: column; `};
`

export const ExpandButton = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${Colors.Neutral10};
  display: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 0 0 32px;

  ${Media.Laptop` 
    display: flex; 
  `};

  svg {
    color: ${Colors.Neutral50};
  }

  &:hover {
    background-color: ${Colors.Blue10};
    svg {
      color: ${Colors.Blue50};
    }
  }
`

export const NavigationContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  max-width: 352px;
  min-width: 300px;
  min-height: 332px;
  ${Shadows.lightWithBorder.low};
  background-color: ${Colors.White};

  &:hover {
    ${ExpandButton} {
      display: flex;
    }
  }
`

export const NavHeadingContainer = styled.div`
  display: flex;
  align-items: center;
`

export const ContentContainer = styled.div`
  flex: 1;
`

export const NavHeading = styled.h2`
  ${Typography.Caps}
  ${FontWeights.DemiBold}
  
  text-align: center;
  padding: 22px 0 18px;
  flex: 1;
`

export const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const SwiperListItem = styled.li<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
  color: ${Colors.Neutral90};
  border-radius: 16px;
  ${Typography.Body}
  ${Shadows.lightWithBorder.low};
  background-color: ${Colors.White};
`

export const NavListItem = styled.li<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 64px;
  padding: 8px 20px;
  border-right: 3px solid transparent;
  cursor: pointer;
  color: ${Colors.Neutral90};
  ${Typography.Body}

  ${props =>
    props.isActive &&
    `
    color: ${props.theme.text};
    background-color: ${props.theme.soft}50; 
    border-color: ${props.theme.base};
   `};
`

export const ServiceInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ServiceHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${Typography.Body}
  ${FontWeights.Regular}
  width: 100%;
`

export const ProgressBarContainer = styled.div<{ isActive: boolean }>`
  width: 100%;
  height: 4px;
  background: ${({ isActive, theme }) => (isActive ? theme.muted : Colors.Neutral10)}!important;
  border-radius: 3px;
  overflow: hidden;
`

export const ProgressBarFiller = styled.div<{ progress?: number }>`
  height: 100%;
  background: ${props => props.theme.base}!important;
  width: ${({ progress }) => (!progress || progress === 0 ? 1 : progress)}%;
  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
`

export const WidgetContainer = styled.div`
  flex: 2;
`

export const ButtonContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 16px;
`

export const CarouselContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;

  & .swiper-wrapper {
    display: flex !important;
    transition-property: transform !important;
    box-sizing: content-box;
  }

  & .swiper-slide {
    flex-shrink: 0 !important;
    box-sizing: border-box;
  }
`

export const CustomPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;

  .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    background: ${Colors.Neutral20};
    border-radius: 50%;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background: ${Colors.Blue50};
  }
`
